// extracted by mini-css-extract-plugin
export default {"container":"adminBetKursNovo_container__mNGH-","top":"adminBetKursNovo_top__+BVF6","btn":"adminBetKursNovo_btn__YEErF","postContainer":"adminBetKursNovo_postContainer__cZFc2"};